import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useStores } from 'services/useStore';
import { Modal, FloatingLabel, Form, Button, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-extraneous-dependencies
import { TCreateNewCharacterSetup } from 'services/Api';
import { TCreateQuestReturn } from 'stores/GeneratedQuestsStore';
import GenerateQuestPreset from '../Heplers/GenerateQuestPreset';

const maxGenerationCount = 3;

const GenerateQuestDialog: React.FC = observer(() => {
  const { t } = useTranslation();
  const { api, sessionStore, generatedQuestsStore } = useStores();
  const checkManager = (): boolean => api.isManager(sessionStore.session.user_project);
  const [result, setResult] = useState<TCreateQuestReturn[]>();
  const [notice, setNotice] = useState<string | undefined>('');
  const [count, setCount] = useState<number>(1);
  const [showSpiner, setShowSpiner] = useState<boolean>(false);
  //const [autoGenerateImage, setAutoGenerateImage] = useState<boolean>(false);

  const generateQuest = async (event: React.FormEvent) => {
    setShowSpiner(true);
    const setup: TCreateNewCharacterSetup = {
      project_id: sessionStore.session.user_project,
      stage: 1,
    };
    if (count > 1) setup.count = count;
    if (notice) setup.notice = notice;
    console.log(setup);
    const resultData = await api.generateQuest(setup);
    console.log(resultData);
    if (generatedQuestsStore.data?.length) resultData.forEach((r) => generatedQuestsStore.add(r));
    else generatedQuestsStore.set(resultData);
    setShowSpiner(false);
  };
  const setQuestCount = (c: number) => {
    if (c <= maxGenerationCount && c > 0) setCount(c);
  };
  useEffect(() => {
    setResult(generatedQuestsStore.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generatedQuestsStore.data]);
  if (!checkManager()) return <></>;
  return (
    <Modal
      show={sessionStore.appSettings.questGenerateShow}
      size='lg'
      key='editModal'
      onHide={() => api.toggleQuestGenerateDialog(false)}
    >
      <Modal.Header closeButton>{t('generationRobot.quest.header')}</Modal.Header>
      <Modal.Body style={{ backgroundColor: '#0000001c' }}>
        <Form action='#'>
          <Row className='justify-content-md-center'>
            <Col xs lg={12} style={{ position: 'relative' }}>
              <FloatingLabel
                controlId='notice'
                label={notice ? '' : t('generationRobot.quest.noticeDesc')}
                className='mb-3'
              >
                <Form.Control
                  as='textarea'
                  rows={5}
                  size='lg'
                  value={notice || ''}
                  onChange={(e) => setNotice(e.target.value)}
                  placeholder={t('generationRobot.quest.noticeDesc')}
                  style={{ height: '200px' }}
                />
              </FloatingLabel>
            </Col>
          </Row>
          {/*<Row className='justify-content-md-center'>
            <Col xs lg={12} style={{ position: 'relative' }}>
              <Form.Check
                type='checkbox'
                id='custom-switch'
                key='all'
                name='type'
                label={t('generationRobot.autoGenerateImage')}
                checked={autoGenerateImage}
                onChange={(e) => setAutoGenerateImage(e.target.checked)}
              />
            </Col>
  </Row>*/}
          {!showSpiner ? (
            <Row className='justify-content-md-center'>
              <Col xs lg={2}>
                <FloatingLabel
                  controlId='count'
                  label={t('generationRobot.count')}
                  className='mb-3 masterField'
                >
                  <Form.Control
                    type='number'
                    size='lg'
                    value={count}
                    onChange={(e) => setQuestCount(+e.target.value)}
                    placeholder={t('generationRobot.count')}
                  />
                </FloatingLabel>
              </Col>
              <Col xs lg={6} />
              <Col xs lg={4}>
                <Button
                  key='generate'
                  variant='warning'
                  className='col-12'
                  size='lg'
                  type='button'
                  style={{ padding: '13px 0', fontWeight: 'bold' }}
                  onClick={generateQuest}
                >
                  {t('generation.generate')}
                </Button>
              </Col>
            </Row>
          ) : (
            <Row className='justify-content-md-center'>
              <Col>
                <Alert variant='warning'>
                  <Spinner variant='warning' />{' '}
                  <span
                    style={{ display: 'inline-block', position: 'relative', bottom: 7, left: 10 }}
                  >
                    {t('generationRobot.waitNotice')}
                  </span>
                </Alert>
              </Col>
            </Row>
          )}
          <Row className='justify-content-md-center'>
            {result ? (
              <Col key='generated' md={12}>
                {result.map((quest) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <GenerateQuestPreset
                    /*autoGenerateImage={autoGenerateImage}*/
                    key={quest.aiImgId}
                    quest={quest}
                  />
                ))}
              </Col>
            ) : (
              ''
            )}
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
});

export default GenerateQuestDialog;
